import SuccessfulPurchase from './SuccessfulPurchase';

export default SuccessfulPurchase;
